export function getHomepage(state: any) {
    return state.homepage.data;
}

export function isLoading(state: any) {
    return state.homepage.isLoading;
}
